import { Injectable } from '@angular/core';
import { IEntityPathService, INamedEntity } from 'interfaces-lib';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InveniasEntityPathService implements IEntityPathService {
  getEntitiesFromPaths(entity: INamedEntity, entityPaths: string[], secondaryEntity?: INamedEntity): Observable<INamedEntity[]> {
    return of([entity]);
  }
}
